import { SharedCallsData } from "@sms/shared/calls/calls.interface";
import { Action, combineReducers, Reducer } from "redux";
import { createReducer, PayloadAction } from "typesafe-actions";

import { mergeArrayAndSortByKey } from "../utils/helpers";

import { createCall, updateCall, initCallsList } from "./calls.actions";

export interface CallsStore {
  calls: SharedCallsData[];
}

export const callsReducer: Reducer<CallsStore> = combineReducers({
  calls: createReducer<SharedCallsData[], Action>([])
    .handleAction(initCallsList, (calls: SharedCallsData[], { payload }: PayloadAction<string, SharedCallsData[]>) =>
      mergeArrayAndSortByKey(calls, payload)
    )
    .handleAction(createCall, (calls: SharedCallsData[], { payload }: PayloadAction<string, SharedCallsData>) =>
      mergeArrayAndSortByKey(calls, [payload], "updated_at", "desc")
    )
    .handleAction(updateCall, (calls: SharedCallsData[], { payload }: PayloadAction<string, SharedCallsData>) =>
      mergeArrayAndSortByKey(calls, [payload], "updated_at", "desc")
    )
});
